module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Icon",
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  }, [_c('svg', {
    staticClass: "Icon-svg",
    style: ({
      fill: _vm.fill
    })
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.icon
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d6a629a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon.vue
// module id = 313
// module chunks = 1